/*! custom-cupom-brinde.js — cupom-brinde e regras de cupom no carrinho do tema

    Espelho, no carrinho do tema (gaveta e /cart), do que a extensao de checkout
    ep-cupom-brinde faz no checkout. A configuracao e a mesma: os metaobjetos
    "Cupom-brinde" e "Regras de cupom", que o snippet ep-cupom-brinde-config
    imprime em JSON no <head>.

      1. Cupom da campanha aplicado (subtotal >= minimo): entra o brinde e o
         cupom do brinde (100% no produto-brinde, quantidade presa em 1); o
         carrinho ja mostra GRATIS.
         Tirou o cupom: saem o cupom do brinde e o produto.
      2. Cupons nao acumulam: o recem-digitado e recusado com aviso no campo.
      3. "Bloquear todos os cupons": so os da lista "cupons que combinam com qualquer
         outro" passam; qualquer outro e removido com aviso.

    Como enxerga as mudancas: embrulha o fetch e, apos qualquer escrita em
    /cart/*.js (do tema ou dos apps), le /cart.js e compara com o estado
    desejado. Uma sincronizacao por vez, nada refeito sem mudanca de estado, e
    ao terminar avisa o tema (evento que os apps de brinde ja usam) para ele
    recarregar a gaveta. O checkout continua com a extensao: chegando la, o
    estado ja esta consistente e ela nao faz nada. */

(function () {
  'use strict';

  var cfgEl = document.getElementById('ep-cupom-brinde-config');
  if (!cfgEl) return;
  var cfg;
  try {
    cfg = JSON.parse(cfgEl.textContent);
  } catch (e) {
    return;
  }
  var campanhas = (cfg.campanhas || []).filter(function (c) {
    return c && c.cupom && c.cupomBrinde && c.varianteId;
  });
  if (!campanhas.length && !cfg.exclusividade && !cfg.bloquearCupons) return;

  var PROP = '_ep_brinde_cupom';
  var SEGUNDOS_AVISO = 8;

  function maiusculo(s) {
    return String(s || '').trim().toUpperCase();
  }
  function curinga(padrao) {
    var partes = maiusculo(padrao).split('*').map(function (p) {
      return p.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    });
    return new RegExp('^' + partes.join('.*') + '$');
  }
  var livres = (cfg.cuponsLivres || []).map(curinga);
  function ehLivre(codigo) {
    return campanhas.some(function (k) { return maiusculo(k.cupomBrinde) === codigo; }) ||
      livres.some(function (re) { return re.test(codigo); });
  }
  /* com "bloquear todos os cupons" so passa o que esta na lista de cupons livres */
  function ehPermitido(codigo) {
    return livres.some(function (re) { return re.test(codigo); });
  }

  /* estado da sincronizacao (vive enquanto a pagina estiver aberta) */
  var rodando = false;
  var pendente = false;
  var ultimaChave = '';
  var codigosAnteriores = null;
  var brindeAnterior = {};
  var removidoPeloCliente = {};

  function post(url, corpo) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corpo)
    }).then(function (r) { return r.json(); });
  }
  function lerCarrinho() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function definirCupons(lista) {
    return post('/cart/update.js', { discount: lista.join(',') });
  }

  var chavesBrinde = {};

  function ler(cart) {
    chavesBrinde = {};
    (cart.items || []).forEach(function (i) {
      if (campanhas.some(function (k) { return i.variant_id === k.varianteId || i.product_id === k.produtoId; })) chavesBrinde[i.key] = true;
    });
    var todos = (cart.discount_codes || []).map(function (d) { return { code: maiusculo(d.code), ok: d.applicable !== false }; });
    var codigos = todos.filter(function (d) { return d.ok; }).map(function (d) { return d.code; });
    var subtotal = (cart.items_subtotal_price || 0) / 100;
    var porCampanha = campanhas.map(function (k) {
      var linha = null;
      (cart.items || []).forEach(function (i) {
        if (!linha && (i.variant_id === k.varianteId || i.product_id === k.produtoId)) linha = i;
      });
      return {
        k: k,
        linha: linha,
        temCupom: codigos.indexOf(maiusculo(k.cupom)) >= 0,
        temCupomBrinde: codigos.indexOf(maiusculo(k.cupomBrinde)) >= 0,
        pago: linha ? linha.final_line_price / 100 : 0
      };
    });
    var chave = JSON.stringify([
      codigos.slice().sort(),
      porCampanha.map(function (p) { return [p.linha && p.linha.key, p.linha && p.linha.quantity]; }),
      subtotal
    ]);
    return { todos: todos, codigos: codigos, subtotal: subtotal, porCampanha: porCampanha, chave: chave };
  }

  function avisar(texto) {
    var campos = document.querySelectorAll('.cart-discount-input__error');
    if (!campos.length) return;
    campos.forEach(function (el) {
      el.textContent = texto;
      el.hidden = false;
      clearTimeout(el.__epAviso);
      el.__epAviso = setTimeout(function () { el.hidden = true; }, SEGUNDOS_AVISO * 1000);
    });
  }

  function avisarTema() {
    /* o tema ja escuta este evento (apps de brinde) e recarrega o estado do carrinho */
    document.dispatchEvent(new CustomEvent('fg-cart:auto-updated'));
  }

  function passo() {
    return lerCarrinho().then(function (cart) {
      var e = ler(cart);
      var anteriores = codigosAnteriores;
      codigosAnteriores = e.codigos;

      /* cliente tirou o brinde a mao (sumiu com o cupom ainda aplicado, e nao fomos nos) */
      e.porCampanha.forEach(function (p) {
        var h = p.k.handle;
        if (brindeAnterior[h] && !p.linha && p.temCupom) removidoPeloCliente[h] = true;
        if (!p.temCupom) removidoPeloCliente[h] = false;
        brindeAnterior[h] = !!p.linha;
      });

      if (e.chave === ultimaChave) return false;
      ultimaChave = e.chave;

      /* 0. todos os cupons bloqueados (so a lista de cupons livres passa) */
      if (cfg.bloquearCupons) {
        var barrados = e.codigos.filter(function (c) { return !ehPermitido(c); });
        if (barrados.length) {
          var ficam = e.todos.map(function (d) { return d.code; }).filter(function (c) { return barrados.indexOf(c) < 0; });
          return definirCupons(ficam).then(function () {
            avisar(cfg.mensagemBloqueio || 'Cupons desativados no momento.');
            return true;
          });
        }
      }

      /* 2. exclusividade de cupons */
      if (cfg.exclusividade) {
        var pagos = e.codigos.filter(function (c) { return !ehLivre(c); });
        if (pagos.length > 1) {
          var novos = anteriores ? pagos.filter(function (c) { return anteriores.indexOf(c) < 0; }) : [];
          var remover = novos.length && novos.length < pagos.length ? novos : pagos.slice(1);
          var fica = pagos.filter(function (c) { return remover.indexOf(c) < 0; })[0];
          var restantes = e.todos.map(function (d) { return d.code; }).filter(function (c) { return remover.indexOf(c) < 0; });
          return definirCupons(restantes).then(function () {
            avisar('Não acumula com ' + fica + '.');
            return true;
          });
        }
      }

      /* 1. cupom-brinde, campanha a campanha (uma acao por passo; o proximo passo continua) */
      var fila = Promise.resolve(false);
      e.porCampanha.forEach(function (p) {
        fila = fila.then(function (mudou) {
          if (mudou) return true;
          var k = p.k;
          var cupomBrinde = maiusculo(k.cupomBrinde);
          var codigosSem = e.todos.map(function (d) { return d.code; }).filter(function (c) { return c !== cupomBrinde; });
          if (p.temCupom) {
            var base = e.subtotal - p.pago;
            if (base < Number(k.minimo || 0)) {
              if (!p.linha && !p.temCupomBrinde) return false;
              var tira = [];
              if (p.linha) tira.push(post('/cart/change.js', { id: p.linha.key, quantity: 0 }));
              return Promise.all(tira).then(function () {
                return p.temCupomBrinde ? definirCupons(codigosSem) : null;
              }).then(function () {
                avisar('Compra mínima: R$ ' + Number(k.minimo).toFixed(2).replace('.', ',') + '.');
                return true;
              });
            }
            if (!p.linha) {
              if (removidoPeloCliente[k.handle]) return false;
              var props = {};
              props[PROP] = k.cupom;
              return post('/cart/add.js', { items: [{ id: k.varianteId, quantity: 1, properties: props }] }).then(function (r) {
                if (r && r.status && r.status !== 200) {
                  if (window.console) console.warn('[ep-cupom-brinde] nao adicionou o brinde:', r.description || r.message);
                  return true;
                }
                /* ja emenda o cupom do brinde: o carrinho mostra GRATIS de uma vez */
                return definirCupons(codigosSem.concat([cupomBrinde])).then(function () { return true; });
              });
            }
            if (p.linha.quantity > 1) {
              /* o cupom do brinde da 100% em qualquer quantidade: uma unidade por pedido */
              return post('/cart/change.js', { id: p.linha.key, quantity: 1 }).then(function () { return true; });
            }
            if (!p.temCupomBrinde) {
              return definirCupons(codigosSem.concat([cupomBrinde])).then(function () { return true; });
            }
            return false;
          }
          /* sem o cupom: sai o cupom do brinde e sai o produto */
          if (!p.linha && !p.temCupomBrinde) return false;
          var acoes = [];
          if (p.linha) acoes.push(post('/cart/change.js', { id: p.linha.key, quantity: 0 }));
          return Promise.all(acoes).then(function () {
            return p.temCupomBrinde ? definirCupons(codigosSem) : null;
          }).then(function () { return true; });
        });
      });
      return fila;
    });
  }

  function sincronizar() {
    if (rodando) {
      pendente = true;
      return;
    }
    rodando = true;
    var mudouAlgo = false;
    var loop = function () {
      pendente = false;
      return passo().then(function (mudou) {
        if (mudou) mudouAlgo = true;
        if (mudou || pendente) return loop();
      });
    };
    loop().catch(function (e) {
      if (window.console) console.warn('[ep-cupom-brinde]', e);
    }).then(function () {
      rodando = false;
      if (mudouAlgo) {
        avisarTema();
        /* confere de novo daqui a pouco: outro app pode ter regravado os cupons no meio */
        setTimeout(sincronizar, 2500);
      }
    });
  }

  /* escritas no carrinho, do tema ou de apps, disparam a sincronizacao */
  /* espera 400 ms de silencio, mas no maximo 1,5 s desde o primeiro pedido: os apps de brinde
     fazem rajadas de 5-6 escritas seguidas e senao a gente so entra depois delas */
  var agendado = null;
  var primeiroPedido = 0;
  function agendar() {
    var agora = Date.now();
    if (!primeiroPedido) primeiroPedido = agora;
    clearTimeout(agendado);
    var espera = Math.max(0, Math.min(400, primeiroPedido + 1500 - agora));
    agendado = setTimeout(function () {
      primeiroPedido = 0;
      sincronizar();
    }, espera);
  }
  var ESCRITA = /\/cart\/(add|update|change|clear)(\.js)?(\?|$)/;
  var fetchOriginal = window.fetch;
  window.fetch = function (entrada, init) {
    var url = typeof entrada === 'string' ? entrada : (entrada && entrada.url) || '';
    var p = fetchOriginal.call(window, entrada, init);
    if (ESCRITA.test(url)) p.then(agendar, function () {});
    return p;
  };
  var abrirOriginal = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (metodo, url) {
    if (ESCRITA.test(String(url))) this.addEventListener('loadend', agendar);
    return abrirOriginal.apply(this, arguments);
  };

  /* cosmetico: a pilula do cupom do brinde (codigo interno) vira "BRINDE" sem lixeira na linha do
     brinde e some das outras linhas (a Shopify tambem marca os itens que qualificaram a compra) */
  var cuponsBrinde = campanhas.map(function (k) { return maiusculo(k.cupomBrinde); });
  function disfarcarPilulas() {
    document.querySelectorAll('.cart-item__discount-pill-label').forEach(function (el) {
      if (el.__epDisfarce || cuponsBrinde.indexOf(maiusculo(el.textContent)) < 0) return;
      el.__epDisfarce = true;
      var pilula = el.closest('.cart-item__discount-pill');
      var item = el.closest('cart-item');
      var chave = item && item.getAttribute('data-key');
      if (chave && !chavesBrinde[chave]) {
        if (pilula) pilula.remove();
        return;
      }
      el.textContent = 'BRINDE';
      var lixeira = pilula && pilula.querySelector('.cart-item__discount-pill-remove');
      if (lixeira) lixeira.remove();
    });
  }
  var disfarceAgendado = null;
  new MutationObserver(function () {
    clearTimeout(disfarceAgendado);
    disfarceAgendado = setTimeout(disfarcarPilulas, 100);
  }).observe(document.documentElement, { childList: true, subtree: true });
  disfarcarPilulas();

  /* reconciliacao periodica enquanto a aba esta visivel: um GET em /cart.js a cada 8 s, sem
     escrita alguma quando o estado ja esta certo (a chave de estado garante isso) */
  setInterval(function () {
    if (document.visibilityState === 'visible') sincronizar();
  }, 8000);

  /* reconcilia ao carregar (ex.: voltou do checkout) */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(sincronizar, 800); });
  else setTimeout(sincronizar, 800);
})();
